import { CustomBuilderComponents } from '@/helpers/enums';
import { LocaleEnum, localizedBuilderProductData } from '@/helpers/enums';

const localesArr = [];
for (const [_key, value] of Object.entries(LocaleEnum)) {
  localesArr.push(value);
}

// set localizeRef for product data model
let localizedRefId = localizedBuilderProductData[LocaleEnum.EN_US];
// only run client side
if (typeof window !== 'undefined') {
  localesArr.forEach(locale => {
    if (window.location.pathname.indexOf(`/${locale}`) === 0) {
      localizedRefId = localizedBuilderProductData[locale];
      return;
    }
  });
}

export const productListingBuilderConfigs = {
  name: CustomBuilderComponents.PRODUCT_LISTING,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/stack.svg',
  inputs: [
    {
      name: 'isFilterEnabled',
      type: 'boolean',
      helperText:
        'Filter is automatically generated based off of product data values',
      defaultValue: true,
    },
    {
      name: 'products',
      type: 'list',
      copyOnAdd: false,
      subFields: [
        {
          name: 'product',
          type: 'reference',
          modelId: localizedRefId,
        },
      ],
    },
  ],
  shouldReceiveBuilderProps: {
    builderBlock: true,
  },
};
